module.exports = __webpack_public_path__ + "static/media/06.987a0f2f.jpg";